import { Suspense, lazy } from 'react';
import { Route, Routes } from 'react-router-dom';

const VhcReportWrapper = lazy(() =>
  import('features/vhc/pages/reports/vhc-record-report/vhc-report/vhc-report-wrapper').then((m) => ({
    default: m.VhcReportWrapper
  }))
);

export const UnauthorizedRoutes = () => {
  return (
    <Routes>
      <Route
        path="/vhc/report/:id"
        element={
          <Suspense fallback={<div>Loading...</div>}>
            <VhcReportWrapper />
          </Suspense>
        }
      />
    </Routes>
  );
};
